// Shopify Configuration
// Replace these with your actual Shopify store credentials

export const SHOPIFY_CONFIG = {
  domain: import.meta.env.VITE_SHOPIFY_DOMAIN || 'wzc12x-te.myshopify.com',
  storefrontAccessToken: import.meta.env.VITE_SHOPIFY_STOREFRONT_ACCESS_TOKEN || 'afa292f2151baafa4c844e58494fe0b6',
  
  // Real Product IDs from Shopify store
  productIds: {
    'pbx-strike-shirt': 'gid://shopify/Product/8755661799662',
    'pbx-shield-shirt': 'gid://shopify/Product/8763979596014',
  },
  
  // Real Variant IDs from Shopify store
  variantIds: {
    // Strike Product Variants
    'strike-unknown-black': 'gid://shopify/ProductVariant/46273470562542',
    'strike-unknown-white': 'gid://shopify/ProductVariant/46273470595310',
    'strike-unknown-blue': 'gid://shopify/ProductVariant/46273470628078',
    'strike-unknown-purple': 'gid://shopify/ProductVariant/46273470660846',
    'strike-unknown-yellow': 'gid://shopify/ProductVariant/46273470693614',
    'strike-unknown-red': 'gid://shopify/ProductVariant/46273470726382',
    'strike-unknown-orange': 'gid://shopify/ProductVariant/46273470759150',
    'strike-unknown-green': 'gid://shopify/ProductVariant/46273470791918',
    'strike-unknown-pink': 'gid://shopify/ProductVariant/46273470824686',

    // Shield Product Variants  
    'shield-unknown-black': 'gid://shopify/ProductVariant/46273471840494',
    'shield-unknown-white': 'gid://shopify/ProductVariant/46273471873262',
    'shield-unknown-gray': 'gid://shopify/ProductVariant/46273471906030',
    'shield-unknown-yellow': 'gid://shopify/ProductVariant/46273471938798',
    'shield-unknown-red': 'gid://shopify/ProductVariant/46273471971566',
    'shield-unknown-orange': 'gid://shopify/ProductVariant/46273472004334',
    'shield-unknown-green': 'gid://shopify/ProductVariant/46273472037102',
    'shield-unknown-purple': 'gid://shopify/ProductVariant/46273472069870',
    'shield-unknown-pink': 'gid://shopify/ProductVariant/46273472102638',
    'shield-unknown-blue': 'gid://shopify/ProductVariant/46273472135406',
  },
  
  // Test Product IDs - Update these with real Shopify product IDs
  testProductIds: {
    'mens-cooling-crew': 'gid://shopify/Product/1234567890',
    'sport-tek-hoodie': 'gid://shopify/Product/1234567891', 
    'womens-cooling-crew': 'gid://shopify/Product/1234567892',
  },
  
  // Test Variant IDs - Update these with real Shopify variant IDs
  testVariantIds: {
    'crew-s-navy': 'gid://shopify/ProductVariant/1234567890',
    'crew-m-navy': 'gid://shopify/ProductVariant/1234567891',
    'crew-l-navy': 'gid://shopify/ProductVariant/1234567892',
    'hoodie-s-navy': 'gid://shopify/ProductVariant/1234567893',
    'hoodie-m-navy': 'gid://shopify/ProductVariant/1234567894',
    'wcrew-s-sage': 'gid://shopify/ProductVariant/1234567895',
  }
};

// Helper to check if Shopify is properly configured
export const isShopifyConfigured = () => {
  return SHOPIFY_CONFIG.storefrontAccessToken !== 'your-storefront-access-token' &&
         SHOPIFY_CONFIG.domain !== 'pbx-pickle-dev.myshopify.com';
};

// Development mode helper
export const isDevelopmentMode = () => {
  return !isShopifyConfigured();
}; 